import { createContext } from 'react';

import { Country } from '../HostedForm.types';

export const CountriesContext = createContext<Array<Country> | undefined>(undefined);
